module.exports = __webpack_public_path__ + "media/public/img/operator-banner-d6997d1700b7e3caaf8e4b7eff8ef1d9.jpg";